export default "__VITE_ASSET__CTrQVDdT__"